import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'egi-modal',
  templateUrl: './egi-modal.component.html',
  styleUrls: ['./egi-modal.component.css'],
})
export class EgiModalComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  @Input() show: boolean = false;
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md';

  @ViewChild('myModal') modal: ElementRef;
  @Output() close = new EventEmitter();

  showing: boolean = false;
  constructor() {}

  ngOnInit(): void {
    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  ngAfterViewInit() {
    if (this.show) {
      this.showModal();
    }
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.onDocumentClick.bind(this));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.show.firstChange)
      if (changes.show.currentValue) {
        this.showModal();
      } else {
        this.hideModal();
      }
  }

  cancel() {
    this.hideModal();
  }

  showModal(): void {
    this.modal.nativeElement.style.display = 'block';
    this.modal.nativeElement.classList.add('show');
    _.delay(() => {
      this.showing = true;
    }, 100);
  }

  hideModal(): void {
    this.showing = false;
    this.modal.nativeElement.style.display = 'none';
    this.modal.nativeElement.classList.remove('show');
    this.close.emit('close');
  }

  onDocumentClick(event: MouseEvent): void {
    if (!this.showing) return;

    const modalContent =
      this.modal.nativeElement.querySelector('.modal-content');
    const target = event.target as Node;

    if (modalContent && modalContent.contains(target)) return;

    const rect = modalContent.getBoundingClientRect();
    const isClickInside =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (isClickInside) {
      return;
    }

    this.hideModal();
  }
}
